export enum StatusExecuteProcess{
    Started,
    Finished,
    Failed
}